var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { switchTenantActions } from "../actions/switchTenantActions";
import { userSelfEditActions } from '../actions/userSelfEditActions';
var initialState = {
    userSelfEditListVisible: false,
    userSelfEditModalVisible: false,
    userSelfEditPassModalVisible: false,
    switchTenantButtonVisible: false
};
var reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case userSelfEditActions.SHOW_SELF_EDIT_USER_LIST:
            return __assign(__assign({}, state), { userSelfEditListVisible: true });
        case userSelfEditActions.HIDE_SELF_EDIT_USER_LIST:
            return __assign(__assign({}, state), { userSelfEditListVisible: false });
        case userSelfEditActions.SHOW_SELF_EDIT_USER_MODAL:
            return __assign(__assign({}, state), { userSelfEditModalVisible: true });
        case userSelfEditActions.HIDE_SELF_EDIT_USER_MODAL:
            return __assign(__assign({}, state), { userSelfEditModalVisible: false });
        case userSelfEditActions.SHOW_SELF_EDIT_PASS_MODAL:
            return __assign(__assign({}, state), { userSelfEditPassModalVisible: true });
        case userSelfEditActions.HIDE_SELF_EDIT_PASS_MODAL:
            return __assign(__assign({}, state), { userSelfEditPassModalVisible: false });
        case switchTenantActions.SHOW_SWITCH_TENANT_BUTTON:
            return __assign(__assign({}, state), { switchTenantButtonVisible: true });
        case switchTenantActions.HIDE_SWITCH_TENANT_BUTTON:
            return __assign(__assign({}, state), { switchTenantButtonVisible: false });
    }
    return state;
};
export default reducer;



//////////////////
// WEBPACK FOOTER
// ./src/reducers/headerReducer.ts
// module id = 631
// module chunks = 0